import {lazy} from "react";

const SearchOrganizationalUnit = lazy(() => import("./SearchOrganizationalUnit"));

const organizationalUnitRoutes = [
    {
        path: "/organizational-unit",
        element: <SearchOrganizationalUnit/>,
    },
];

export default organizationalUnitRoutes;